var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDuplicateS(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "dd0140aa-3970-46fa-b5df-a3bfe91cd747@1.00x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#2C2C30",
    fillRule: "nonzero",
    x: -2834,
    y: -4764,
    width: 9954,
    height: 9222
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Background_Bright-UI",
    fill: "#F2F2F2",
    fillRule: "nonzero",
    x: -106,
    y: -4591,
    width: 170,
    height: 6380
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons/bright-UI/Duplicate_S",
    fill: "#0D3968",
    fillOpacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,9.0003 L8,11.0003 L5,11.0003 L5,19.0003 L13,19.0003 L13,15.9993 L15,15.9993 L15,21.0003 L3,21.0003 L3,9.0003 L8,9.0003 Z M21,3 L21,14 L10,14 L10,3 L21,3 Z",
    id: "Combined-Shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicateS);
export default __webpack_public_path__ + "static/media/duplicateS.5add0f52734582080438160f2b67fde7.svg";
export { ForwardRef as ReactComponent };